module.exports = __webpack_public_path__ + "img/list_layanan_keuangan.0a992efe.jpg";